import React from 'react';
import { Box, keyframes } from '@chakra-ui/react';
import { Check } from '@mui/icons-material';

// Button label that slides up and out while "Added ✓" slides in from below (design-system.md §8.2)
const slideOut = keyframes`from { transform: translateY(0); opacity: 1 } to { transform: translateY(-1em); opacity: 0 }`;
const slideIn = keyframes`from { transform: translateY(.5em); opacity: 0 } to { transform: translateY(0); opacity: 1 }`;

const AddedLabel = ({ added, children }) => (
    <Box as='span' position='relative' display='inline-flex' alignItems='center' justifyContent='center' >
        <Box as='span' display='inline-flex' alignItems='center' gap='8px' animation={added ? `${slideOut} .125s ease-in-out forwards` : undefined} >{children}</Box>
        {added &&
            <Box as='span' position='absolute' inset={0} display='flex' alignItems='center' justifyContent='center' gap='6px' whiteSpace='nowrap' animation={`${slideIn} .125s ease-in-out .06s both`} >
                Added <Check sx={{ fontSize: 18 }} />
            </Box>}
    </Box>
);

export default AddedLabel;
